import CircularProgress from '@mui/material/CircularProgress';
import renderIcon from 'icon';
import { useState } from 'react';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useQuery } from 'react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EmptyCon } from '../../../components/atoms';
import { RateBox, RateModal } from '../../../components/molecules';
import { getCompletedOrders } from '../../../network/services/order';
import { BasicBox, EmptyCON } from '../styles';

export const Reviews = () => {
  const navigate = useNavigate();
  const [searcParams] = useSearchParams();
  const prodId = searcParams.get('page') ?? '0';

  const [id, setId] = useState(0);
  const { data, isLoading } = useQuery(['reviews', { prodId }], () => getCompletedOrders(), {});

  const rateProduct = data || [];
  console.log(rateProduct);

  return (
    <>
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
        {renderIcon(IoArrowBackCircleSharp, {
          size: 24,
          className: 'text-black flex-shrink-0 cursor-pointer hover:text-gray-600 transition-colors',
          onClick: () => navigate('/account')
        })}
        <span
          className="font-semibold"
          style={{ color: '#222', cursor: 'pointer' }}
          onClick={() => navigate('/account')}>
          Account
        </span>
        <span>›</span>
        <span className="font-semibold" style={{ color: '#222' }}>
          Reviews
        </span>
      </div>
      <BasicBox>
        <div className="header">Reviews ({rateProduct.filter(x => x.status === 'completed').length})</div>
        {isLoading && (
          <EmptyCon>
            <CircularProgress size={30} />
          </EmptyCon>
        )}
        {!isLoading &&
          Array.isArray(rateProduct) &&
          rateProduct.length > 0 &&
          rateProduct
            .filter(x => x.status === 'completed')
            .map(item => {
              return <RateBox item={item} key={item.id} setId={setId} />;
            })}
        {!isLoading && !rateProduct.length && <EmptyCON>No Item to Review</EmptyCON>}

        {id > 0 && <RateModal setId={setId} id={id} />}
      </BasicBox>
    </>
  );
};
